import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.055 2.055A2.75 2.75 0 0 1 6 1.25h8a.75.75 0 0 1 .53.22l6 6c.141.14.22.331.22.53v12A2.75 2.75 0 0 1 18 22.75H6A2.756 2.756 0 0 1 3.25 20V4c0-.73.29-1.429.805-1.945M6 2.75A1.25 1.25 0 0 0 4.75 4v16c0 .686.564 1.25 1.25 1.25h12A1.25 1.25 0 0 0 19.25 20V8.31l-5.56-5.56z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11 11.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.25 12a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h1.75v-2.5H11a.75.75 0 0 1-.75-.75M14 1.25a.75.75 0 0 1 .75.75v5.25H20a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }